/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PaginatedWeeklyQueueList,
  WeeklyQueue,
  WeeklyQueueCreate,
  WeeklyQueueCreateRequest,
  WeeklyQueueListParams,
  WeeklyQueueRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자의 채널 기준 위클리 큐 목록을 반환합니다.
 * @summary 위클리 생성 큐 목록
 */
export const weeklyQueueList = (
  params?: WeeklyQueueListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedWeeklyQueueList>(
    { url: `/api/weekly-queues/`, method: "GET", params, signal },
    options,
  );
};

export const getWeeklyQueueListQueryKey = (params?: WeeklyQueueListParams) => {
  return [`/api/weekly-queues/`, ...(params ? [params] : [])] as const;
};

export const getWeeklyQueueListQueryOptions = <
  TData = Awaited<ReturnType<typeof weeklyQueueList>>,
  TError = ErrorType<unknown>,
>(
  params?: WeeklyQueueListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWeeklyQueueListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof weeklyQueueList>>> = ({
    signal,
  }) => weeklyQueueList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof weeklyQueueList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WeeklyQueueListQueryResult = NonNullable<
  Awaited<ReturnType<typeof weeklyQueueList>>
>;
export type WeeklyQueueListQueryError = ErrorType<unknown>;

export function useWeeklyQueueList<
  TData = Awaited<ReturnType<typeof weeklyQueueList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | WeeklyQueueListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof weeklyQueueList>>,
          TError,
          Awaited<ReturnType<typeof weeklyQueueList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWeeklyQueueList<
  TData = Awaited<ReturnType<typeof weeklyQueueList>>,
  TError = ErrorType<unknown>,
>(
  params?: WeeklyQueueListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof weeklyQueueList>>,
          TError,
          Awaited<ReturnType<typeof weeklyQueueList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWeeklyQueueList<
  TData = Awaited<ReturnType<typeof weeklyQueueList>>,
  TError = ErrorType<unknown>,
>(
  params?: WeeklyQueueListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 위클리 생성 큐 목록
 */

export function useWeeklyQueueList<
  TData = Awaited<ReturnType<typeof weeklyQueueList>>,
  TError = ErrorType<unknown>,
>(
  params?: WeeklyQueueListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWeeklyQueueListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 이번 주 플레이리스트 생성 목표를 등록합니다. week_start는 서버에서 자동 계산.
 * @summary 위클리 생성 큐 생성
 */
export const weeklyQueueCreate = (
  weeklyQueueCreateRequest: BodyType<WeeklyQueueCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<WeeklyQueueCreate>(
    {
      url: `/api/weekly-queues/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: weeklyQueueCreateRequest,
      signal,
    },
    options,
  );
};

export const getWeeklyQueueCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weeklyQueueCreate>>,
    TError,
    { data: BodyType<WeeklyQueueCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weeklyQueueCreate>>,
  TError,
  { data: BodyType<WeeklyQueueCreateRequest> },
  TContext
> => {
  const mutationKey = ["weeklyQueueCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weeklyQueueCreate>>,
    { data: BodyType<WeeklyQueueCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return weeklyQueueCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeeklyQueueCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof weeklyQueueCreate>>
>;
export type WeeklyQueueCreateMutationBody = BodyType<WeeklyQueueCreateRequest>;
export type WeeklyQueueCreateMutationError = ErrorType<unknown>;

/**
 * @summary 위클리 생성 큐 생성
 */
export const useWeeklyQueueCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof weeklyQueueCreate>>,
      TError,
      { data: BodyType<WeeklyQueueCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof weeklyQueueCreate>>,
  TError,
  { data: BodyType<WeeklyQueueCreateRequest> },
  TContext
> => {
  const mutationOptions = getWeeklyQueueCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 위클리 생성 큐 CRUD + Pause/Resume.
 * @summary 위클리 생성 큐 상세
 */
export const weeklyQueueRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<WeeklyQueue>(
    { url: `/api/weekly-queues/${id}/`, method: "GET", signal },
    options,
  );
};

export const getWeeklyQueueRetrieveQueryKey = (id?: string) => {
  return [`/api/weekly-queues/${id}/`] as const;
};

export const getWeeklyQueueRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWeeklyQueueRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof weeklyQueueRetrieve>>
  > = ({ signal }) => weeklyQueueRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WeeklyQueueRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof weeklyQueueRetrieve>>
>;
export type WeeklyQueueRetrieveQueryError = ErrorType<unknown>;

export function useWeeklyQueueRetrieve<
  TData = Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
          TError,
          Awaited<ReturnType<typeof weeklyQueueRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWeeklyQueueRetrieve<
  TData = Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
          TError,
          Awaited<ReturnType<typeof weeklyQueueRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWeeklyQueueRetrieve<
  TData = Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 위클리 생성 큐 상세
 */

export function useWeeklyQueueRetrieve<
  TData = Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof weeklyQueueRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWeeklyQueueRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 위클리 생성 큐 CRUD + Pause/Resume.
 * @summary 위클리 생성 큐 삭제
 */
export const weeklyQueueDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/weekly-queues/${id}/`, method: "DELETE" },
    options,
  );
};

export const getWeeklyQueueDestroyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weeklyQueueDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weeklyQueueDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["weeklyQueueDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weeklyQueueDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return weeklyQueueDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeeklyQueueDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof weeklyQueueDestroy>>
>;

export type WeeklyQueueDestroyMutationError = ErrorType<unknown>;

/**
 * @summary 위클리 생성 큐 삭제
 */
export const useWeeklyQueueDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof weeklyQueueDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof weeklyQueueDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getWeeklyQueueDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * POST /api/playlists/weekly-queues/{id}/pause/
 * @summary 위클리 생성 큐 일시정지
 */
export const weeklyQueuePause = (
  id: string,
  weeklyQueueRequest: BodyType<WeeklyQueueRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<WeeklyQueue>(
    {
      url: `/api/weekly-queues/${id}/pause/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: weeklyQueueRequest,
      signal,
    },
    options,
  );
};

export const getWeeklyQueuePauseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weeklyQueuePause>>,
    TError,
    { id: string; data: BodyType<WeeklyQueueRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weeklyQueuePause>>,
  TError,
  { id: string; data: BodyType<WeeklyQueueRequest> },
  TContext
> => {
  const mutationKey = ["weeklyQueuePause"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weeklyQueuePause>>,
    { id: string; data: BodyType<WeeklyQueueRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return weeklyQueuePause(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeeklyQueuePauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof weeklyQueuePause>>
>;
export type WeeklyQueuePauseMutationBody = BodyType<WeeklyQueueRequest>;
export type WeeklyQueuePauseMutationError = ErrorType<unknown>;

/**
 * @summary 위클리 생성 큐 일시정지
 */
export const useWeeklyQueuePause = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof weeklyQueuePause>>,
      TError,
      { id: string; data: BodyType<WeeklyQueueRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof weeklyQueuePause>>,
  TError,
  { id: string; data: BodyType<WeeklyQueueRequest> },
  TContext
> => {
  const mutationOptions = getWeeklyQueuePauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * POST /api/playlists/weekly-queues/{id}/resume/
 * @summary 위클리 생성 큐 재개
 */
export const weeklyQueueResume = (
  id: string,
  weeklyQueueRequest: BodyType<WeeklyQueueRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<WeeklyQueue>(
    {
      url: `/api/weekly-queues/${id}/resume/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: weeklyQueueRequest,
      signal,
    },
    options,
  );
};

export const getWeeklyQueueResumeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weeklyQueueResume>>,
    TError,
    { id: string; data: BodyType<WeeklyQueueRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weeklyQueueResume>>,
  TError,
  { id: string; data: BodyType<WeeklyQueueRequest> },
  TContext
> => {
  const mutationKey = ["weeklyQueueResume"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weeklyQueueResume>>,
    { id: string; data: BodyType<WeeklyQueueRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return weeklyQueueResume(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeeklyQueueResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof weeklyQueueResume>>
>;
export type WeeklyQueueResumeMutationBody = BodyType<WeeklyQueueRequest>;
export type WeeklyQueueResumeMutationError = ErrorType<unknown>;

/**
 * @summary 위클리 생성 큐 재개
 */
export const useWeeklyQueueResume = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof weeklyQueueResume>>,
      TError,
      { id: string; data: BodyType<WeeklyQueueRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof weeklyQueueResume>>,
  TError,
  { id: string; data: BodyType<WeeklyQueueRequest> },
  TContext
> => {
  const mutationOptions = getWeeklyQueueResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
